import { ColumnDef } from '@tanstack/react-table';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Text } from 'theme-ui';
import { setPagination } from '../../../../store/actions/Pagination.action';
import TableActions from '../../users/TableActions';
import { useNavigate } from 'react-router-dom';
import { getAllDepartmentTypes } from '../../../../store/actions/departmentAction';
import { TabelHeadingTxt } from '../../../Text/TabelCommonTxt';
import DataTable from '../../../Tabels/Tabel';
import plus from "../../../assets/images/Icon/plus.svg";

const DepartmentMasterData: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state: any) => state.departmentTypes);
    const { paginations } = useSelector((state: any) => state.pagination);

    /* ===================== FETCH DEPARTMENTS ON MOUNT ===================== */
    useEffect(() => {
        dispatch(getAllDepartmentTypes());
    }, []);

    /* ===================== COLUMNS ===================== */
    const columns = useMemo<ColumnDef<any>[]>(() => [
        {
            header: 'No',
            enableColumnFilter: false,
            cell: ({ row }) => (
                <Text variant='Poppins14Normal24lh'>
                    {((paginations.currentPage - 1) * paginations.limit) + row.index + 1}
                </Text>
            )
        },
        {
            accessorKey: "name",
            header: 'Department Name',
            cell: info => info.getValue(),
        },
        {
            header: 'Accessor',
            enableColumnFilter: false,
            cell: ({ row }) => (
                <TableActions
                    row={row}
                    editTo={`/edit-department-type/${row.original._id}`}
                    deleteMessage='Are you sure you want to delete this department?'
                    deleteApi={`department/delete-department-type/${row.original._id}`}
                    toggleRefresh={() => dispatch(getAllDepartmentTypes())} // optional refresh
                />
            ),
        }
    ], [paginations, dispatch]);

    /* ===================== RESET PAGINATION ON UNMOUNT ===================== */
    useEffect(() => {
        return () => {
            dispatch(setPagination({
                limit: 15,
                currentPage: 1,
            }));
        };
    }, [dispatch]);

    const paginatedList = useMemo(() => {
        if (!Array.isArray(list)) return [];

        const startIndex = (paginations.currentPage - 1) * paginations.limit;
        const endIndex = startIndex + paginations.limit;

        return list.slice(startIndex, endIndex);
    }, [list, paginations.currentPage, paginations.limit]);

    const handleCreate = () => {
        navigate("/create-department-type");
    };

    return (
        <div className='main-content'>
            <TabelHeadingTxt
                Title='Departments'
                Count={Array.isArray(list) ? list.length : 0}
                BtnTxt='Create Department'
                src={plus}
                onClick={handleCreate}
                sx={{ backgroundColor: '#7743DB', color: 'white' }}
            />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loading}
                columns={columns}
                data={paginatedList}
                TotalLength={Array.isArray(list) ? list.length : 0}
                perPageCount={paginations.limit}
                currentPage={paginations.currentPage}
                onPerPageChange={(itemsPerPage) => {
                    dispatch(setPagination({
                        limit: itemsPerPage,
                        currentPage: 1
                    }));
                }}
                onPageChange={(value) => {
                    dispatch(setPagination({
                        ...paginations,
                        currentPage: value
                    }));
                }}
            />
        </div>
    );
};

export default DepartmentMasterData;
